import { ORANGE_FROM_MINUTE, WAIT_COLOR, WAIT_TOLERANCE_MINUTES } from '../../utils/kitchenWaitCounter.js'
import { MAX_PLAUSIBLE_WAIT_HOURS } from '../../utils/dealerWaitThresholds.js'

export const LIVE_WAIT_LABEL = {
  ON_TIME: 'A tiempo',
  ATTENTION: 'Atención',
  DELAYED: 'Con demora',
  NOT_COUNTED: 'No cuenta',
  NO_ARRIVAL: 'Sin llegada'
}

export const LIVE_WAIT_TONE = {
  NOT_COUNTED: 'info',
  NO_ARRIVAL: 'indigo'
}

export const LEGEND_TITLE = '¿Qué significa cada estado?'

export const LEGEND_CLOSE_LABEL = 'Entendido'

const WAITING_VERB = 'Lleva'
const WAITED_VERB = 'Esperó'
const OTHER_ROUTE_NAME = 'otra ruta'

export const LIVE_WAIT_TEXT = {
  BLOCKED_BY_MV: 'MV frenó la ruta mientras el repartidor esperaba.',
  ORDER_ADDED: 'MV agregó un pedido cuando el repartidor ya estaba en la cocina.',
  MANUAL_ARRIVAL: 'La llegada la marcó MV a mano: no cuenta para el nivel.',
  DISCARDED_WAIT: `Error de marca: la espera pasa de ${MAX_PLAUSIBLE_WAIT_HOURS} horas.`,
  LEFT_EARLY: 'El repartidor salió antes de la hora programada.',
  ATTENTION_FROM_TOLERANCE: `Desde el minuto ${WAIT_TOLERANCE_MINUTES} la espera cuenta como demora.`,
  secondTrip: (firstRoute) =>
    `El repartidor salió primero con ${firstRoute ? `la ${firstRoute}` : OTHER_ROUTE_NAME} y volvió por esta ruta. La espera es del repartidor.`,
  beforeSchedule: (scheduledHour) =>
    `Llegó antes de la hora programada (${scheduledHour}); la espera cuenta desde esa hora.`,
  waitingWithinTolerance: (minutes) => `${WAITING_VERB} ${minutes} min, dentro de los ${WAIT_TOLERANCE_MINUTES} de tolerancia.`,
  waitingInAttention: (minutes) => `${WAITING_VERB} ${minutes} min. ${LIVE_WAIT_TEXT.ATTENTION_FROM_TOLERANCE}`,
  waitingOverTolerance: (minutes, excess) => describeOverTolerance(WAITING_VERB, minutes, excess),
  waitedWithinTolerance: (minutes) => `${WAITED_VERB} ${minutes} min, dentro de los ${WAIT_TOLERANCE_MINUTES} de tolerancia.`,
  waitedOverTolerance: (minutes, excess) => describeOverTolerance(WAITED_VERB, minutes, excess)
}

function describeOverTolerance (verb, minutes, excess) {
  return excess > 0
    ? `${verb} ${minutes} min: ${excess} más que los ${WAIT_TOLERANCE_MINUTES} de tolerancia.`
    : `${verb} ${minutes} min: ya pasó los ${WAIT_TOLERANCE_MINUTES} de tolerancia.`
}

export const LEGEND_ENTRIES = [
  { label: LIVE_WAIT_LABEL.ON_TIME, tone: WAIT_COLOR.GREEN, meaning: `Menos de ${ORANGE_FROM_MINUTE} min de espera` },
  { label: LIVE_WAIT_LABEL.ATTENTION, tone: WAIT_COLOR.ORANGE, meaning: `Desde ${ORANGE_FROM_MINUTE} min (suena un aviso)` },
  { label: LIVE_WAIT_LABEL.DELAYED, tone: WAIT_COLOR.RED, meaning: `Desde ${WAIT_TOLERANCE_MINUTES} min: pasó la tolerancia` },
  { label: LIVE_WAIT_LABEL.NOT_COUNTED, tone: LIVE_WAIT_TONE.NOT_COUNTED, meaning: 'La espera no es de la cocina' },
  { label: LIVE_WAIT_LABEL.NO_ARRIVAL, tone: LIVE_WAIT_TONE.NO_ARRIVAL, meaning: 'El repartidor aún no marcó su llegada' }
]
